export enum SaleListHeaderFilterClosedEnum {
    CLOSED, OPENED, BOTH
}
